import cn from 'classnames';

import styles from './labels.module.css';

export const Verified = () => <div className={cn(styles.label, styles.verified)}>Проверено</div>;
